export const TIME_ZONE_GROUPS = {
  US: 'United States & Canada',
  AMERICA: 'America',
  AFRICA: 'Africa',
  ASIA: 'Asia',
  ATLANTIC: 'Atlantic',
  AUSTRALIA: 'Australia',
  UTC: 'UTC',
  EUROPE: 'Europe',
  PACIFIC: 'Pacific',
} as const

export const TIME_ZONE_MAPPINGS: Record<
  string,
  { zone: string; group: keyof typeof TIME_ZONE_GROUPS }
> = {
  // US & Canada
  'Pacific time - US & Canada': { zone: 'America/Los_Angeles', group: 'US' },
  'Mountain time - US & Canada': { zone: 'America/Denver', group: 'US' },
  'Central time - US & Canada': { zone: 'America/Chicago', group: 'US' },
  'Eastern time - US & Canada': { zone: 'America/New_York', group: 'US' },
  'Alaska time': { zone: 'America/Anchorage', group: 'US' },
  'Arizona, Yukon time': { zone: 'America/Phoenix', group: 'US' },
  'Newfoundland time': { zone: 'America/St_Johns', group: 'US' },
  'Hawaii time': { zone: 'Pacific/Honolulu', group: 'US' },

  // America
  'Adak time': { zone: 'America/Adak', group: 'AMERICA' },
  'Buenos Aires time': {
    zone: 'America/Argentina/Buenos_Aires',
    group: 'AMERICA',
  },
  'Asuncion time': { zone: 'America/Asuncion', group: 'AMERICA' },
  'Bogota, Jamaica, Lima time': { zone: 'America/Bogota', group: 'AMERICA' },
  'Campo Grande time': { zone: 'America/Campo_Grande', group: 'AMERICA' },
  'Caracas time': { zone: 'America/Caracas', group: 'AMERICA' },
  'Godthab time': { zone: 'America/Godthab', group: 'AMERICA' },
  'Atlantic time': { zone: 'America/Halifax', group: 'AMERICA' },
  'Saskatchewan, Guatemala, Costa Rica time': {
    zone: 'America/Regina',
    group: 'AMERICA',
  },
  'Havana time': { zone: 'America/Havana', group: 'AMERICA' },
  'Mazatlan time': { zone: 'America/Mazatlan', group: 'AMERICA' },
  'Mexico City time': { zone: 'America/Mexico_City', group: 'AMERICA' },
  'Montevideo time': { zone: 'America/Montevideo', group: 'AMERICA' },
  'Miquelon time': { zone: 'America/Miquelon', group: 'AMERICA' },
  'Noronha time': { zone: 'America/Noronha', group: 'AMERICA' },
  'Santiago time': { zone: 'America/Santiago', group: 'AMERICA' },
  'Santa Isabel time': { zone: 'America/Santa_Isabel', group: 'AMERICA' },
  'Atlantic Standard time': { zone: 'America/Puerto_Rico', group: 'AMERICA' },
  'Brasilia time': { zone: 'America/Sao_Paulo', group: 'AMERICA' },

  // Africa
  'Cairo time': { zone: 'Africa/Cairo', group: 'AFRICA' },
  'Central Africa time': { zone: 'Africa/Harare', group: 'AFRICA' },
  'West Africa time': { zone: 'Africa/Lagos', group: 'AFRICA' },
  'Windhoek time': { zone: 'Africa/Windhoek', group: 'AFRICA' },

  // Asia
  'Jordan time': { zone: 'Asia/Amman', group: 'ASIA' },
  'Baghdad, East Africa time': { zone: 'Asia/Baghdad', group: 'ASIA' },
  'Baku time': { zone: 'Asia/Baku', group: 'ASIA' },
  'Lebanon time': { zone: 'Asia/Beirut', group: 'ASIA' },
  'Syria time': { zone: 'Asia/Damascus', group: 'ASIA' },
  'Dhaka time': { zone: 'Asia/Dhaka', group: 'ASIA' },
  'Dubai time': { zone: 'Asia/Dubai', group: 'ASIA' },
  'Gaza time': { zone: 'Asia/Gaza', group: 'ASIA' },
  'Irkutsk time': { zone: 'Asia/Irkutsk', group: 'ASIA' },
  'Indochina time': { zone: 'Asia/Bangkok', group: 'ASIA' },
  'Israel time': { zone: 'Asia/Jerusalem', group: 'ASIA' },
  'Kabul time': { zone: 'Asia/Kabul', group: 'ASIA' },
  'Pakistan, Maldives time': { zone: 'Asia/Karachi', group: 'ASIA' },
  'Kathmandu time': { zone: 'Asia/Kathmandu', group: 'ASIA' },
  'India, Sri Lanka time': { zone: 'Asia/Kolkata', group: 'ASIA' },
  'Krasnoyarsk time': { zone: 'Asia/Krasnoyarsk', group: 'ASIA' },
  'Omsk time': { zone: 'Asia/Omsk', group: 'ASIA' },
  'Rangoon time': { zone: 'Asia/Rangoon', group: 'ASIA' },
  'China, Singapore, Perth': { zone: 'Asia/Shanghai', group: 'ASIA' },
  'Tehran time': { zone: 'Asia/Tehran', group: 'ASIA' },
  'Japan, Korea time': { zone: 'Asia/Tokyo', group: 'ASIA' },
  'Vladivostok time': { zone: 'Asia/Vladivostok', group: 'ASIA' },
  'Asia/Yakutsk': { zone: 'Asia/Yakutsk', group: 'ASIA' },
  'Yekaterinburg time': { zone: 'Asia/Yekaterinburg', group: 'ASIA' },
  'Asia/Yerevan': { zone: 'Asia/Yerevan', group: 'ASIA' },

  // Atlantic
  'Azores time': { zone: 'Atlantic/Azores', group: 'ATLANTIC' },
  'Cape Verde time': { zone: 'Atlantic/Cape_Verde', group: 'ATLANTIC' },

  // Australia
  'Adelaide time': { zone: 'Australia/Adelaide', group: 'AUSTRALIA' },
  'Brisbane time': { zone: 'Australia/Brisbane', group: 'AUSTRALIA' },
  'Darwin time': { zone: 'Australia/Darwin', group: 'AUSTRALIA' },
  'Eucla time': { zone: 'Australia/Eucla', group: 'AUSTRALIA' },
  'Lord Howe time': { zone: 'Australia/Lord_Howe', group: 'AUSTRALIA' },
  'Perth time': { zone: 'Australia/Perth', group: 'AUSTRALIA' },
  'Sydney, Melbourne time': { zone: 'Australia/Sydney', group: 'AUSTRALIA' },

  // UTC
  'UTC time': { zone: 'UTC', group: 'UTC' },

  // Europe
  'Central European time': { zone: 'Europe/Paris', group: 'EUROPE' },
  'Eastern European time': { zone: 'Europe/Bucharest', group: 'EUROPE' },
  'UK, Ireland, Lisbon time': { zone: 'Europe/London', group: 'EUROPE' },
  'Minsk time': { zone: 'Europe/Minsk', group: 'EUROPE' },
  'Moscow time': { zone: 'Europe/Moscow', group: 'EUROPE' },
  'Turkey time': { zone: 'Europe/Istanbul', group: 'EUROPE' },

  // Pacific
  'Apia time': { zone: 'Pacific/Apia', group: 'PACIFIC' },
  'Auckland time': { zone: 'Pacific/Auckland', group: 'PACIFIC' },
  'Chatham time': { zone: 'Pacific/Chatham', group: 'PACIFIC' },
  'Easter time': { zone: 'Pacific/Easter', group: 'PACIFIC' },
  'Fiji time': { zone: 'Pacific/Fiji', group: 'PACIFIC' },
  'Gambier time': { zone: 'Pacific/Gambier', group: 'PACIFIC' },
  'Kiritimati time': { zone: 'Pacific/Kiritimati', group: 'PACIFIC' },
  'Majuro time': { zone: 'Pacific/Majuro', group: 'PACIFIC' },
  'Marquesas time': { zone: 'Pacific/Marquesas', group: 'PACIFIC' },
  'Norfolk time': { zone: 'Pacific/Norfolk', group: 'PACIFIC' },
  'Noumea time': { zone: 'Pacific/Noumea', group: 'PACIFIC' },
  'Pago Pago time': { zone: 'Pacific/Pago_Pago', group: 'PACIFIC' },
  'Pitcairn time': { zone: 'Pacific/Pitcairn', group: 'PACIFIC' },
  'Tarawa time': { zone: 'Pacific/Tarawa', group: 'PACIFIC' },
  'Tongatapu time': { zone: 'Pacific/Tongatapu', group: 'PACIFIC' },
}

export const formatTimezoneLabel = (timeZone: string): string => {
  // First try to find the label in mappings
  const entry = Object.entries(TIME_ZONE_MAPPINGS).find(
    ([_, value]) => value.zone === timeZone,
  )

  if (entry) {
    return entry[0] // Return the label
  }

  // Fallback to formatting from timezone string
  const [continent, ...locationParts] = timeZone.split('/')
  const city = locationParts.join('/').replace(/_/g, ' ')
  return `${city ? `${city}, ` : ''}${continent}`
}
